import React from 'react';
import PropTypes from 'prop-types';

import AmountChanger from './AmountChanger';

const CartItem = ({ product, amount }) => {
    if (product.title === '') {
        return null;
    }

    return (
        <div className="cart-item">
            <h3 className="cart-item__title">{product.title}</h3>
            <div className="cart-item__actions">
                <AmountChanger
                    productSlug={product.slug}
                    amount={amount}
                />
                <span className="cart-item__total">€{(product.price * amount).toFixed(2)}</span>
            </div>
        </div>
    );
};

CartItem.propTypes = {
    product: PropTypes.shape({}).isRequired,
    amount: PropTypes.number.isRequired,
};

export default CartItem;



// WEBPACK FOOTER //
// ./resources/components/shop/components/CartItem.jsx